import { Injectable } from "@angular/core";
import { GridLayoutService } from "@irb-common/interfaces/grid-layout.service";
import { DialogPrThresholdExceededComponent } from "@irb/irb-dialogs/dialog-pr-threshold-exceeded/dialog-pr-threshold-exceeded.component";


@Injectable({
  providedIn: "root",
})
export class DialogPrThresholdExceededGridLayoutService implements GridLayoutService<DialogPrThresholdExceededComponent>
{
  constructor() {}

  getFrameworkComponents() {
    return {};
  }

  getColumnDefs() {
    return [
      {
        headerName: "Portfolio Name",
        field: "portfolioName",
        minWidth: 150,
        width: 230,
        sort: "asc",
        cellRenderer: 'cellRendererFormatter'
      },
      {
        headerName: "Account",
        field: "accountNum",
        maxWidth: 140,
        width: 140
      },
      {
        headerName: "Symbol",
        field: "symbol",
        maxWidth: 120,
        width: 120
      },
      {
        headerName: "Order Type",
        field: "orderType",
        maxWidth: 130,
        width: 130,
        cellStyle: { 'text-transform': 'lowercase' },
        cellClass: "firstLetterStyle"
      },
      {
        headerName: "Amt Type",
        field: "amountType",
        maxWidth: 130,
        width: 130,
        cellStyle: { 'text-transform': 'lowercase' },
        cellClass: "firstLetterStyle"
      },
      {
        headerName: "Order Amt",
        field: "orderAmount",
        maxWidth: 130,
        width: 130,
        cellRenderer: 'cellRendererFormatter',
        cellRendererParams: (params: any) => {
          return { type: 'currency', displaySymbol: (params.data?.amountType === "SHARES") ? ' ' : '$'};
        }
      }
    ];
  }
}
